import { useState } from 'react';
import { Text, Box } from 'roo-ui/components';
import PropTypes from 'prop-types';
import { useUpdateEffect } from 'react-use';
import { STAY_RATINGS } from 'config/constants';
import { getSurveyLink } from 'lib/links';
import { RatingWrapper, RatingButton } from './primitives';

const StayRating = ({ booking, onRated, ...props }) => {
  const [rating, setRating] = useState(null);
  const [className, setClassName] = useState(null);

  useUpdateEffect(() => {
    setClassName('disabled');

    const timeoutRef = setTimeout(() => {
      setClassName('hidden');
    }, 3000);

    return () => clearTimeout(timeoutRef);
  }, [rating]);

  return (
    <>
      <RatingWrapper className={className} {...props}>
        <Text mr={2}>How was your stay?</Text>
        <Box display="inline-block">
          <RatingButton
            name="thumbUp"
            selected={rating === STAY_RATINGS.POSITIVE}
            disabled={!!rating}
            onClick={(event) => {
              event.stopPropagation();
              setRating(STAY_RATINGS.POSITIVE);
              window.open(getSurveyLink(booking), '_blank');
              onRated({ booking, rating: STAY_RATINGS.POSITIVE });
            }}
          />
          <RatingButton
            name="thumbDown"
            selected={rating === STAY_RATINGS.NEGATIVE}
            disabled={!!rating}
            onClick={(event) => {
              event.stopPropagation();
              setRating(STAY_RATINGS.NEGATIVE);
              window.open(getSurveyLink(booking), '_blank');
              onRated({ booking, rating: STAY_RATINGS.NEGATIVE });
            }}
          />
        </Box>
      </RatingWrapper>
    </>
  );
};

StayRating.propTypes = {
  booking: PropTypes.shape({}).isRequired,
  onRated: PropTypes.func.isRequired,
};

export default StayRating;
